<template>
  <!-- <b-card title="User Timeline"> -->
  <app-timeline>
    <!-- 12 INVOICES HAVE BEEN PAID -->

    <app-timeline-item
      variant="warning"
      v-for="item in data"
      :key="item.deliveryDate"
    >
      <div
        class="d-flex flex-sm-row flex-column flex-wrap justify-content-between mb-1 mb-sm-0"
      >
        <h6>
          {{ item.deliveryStatus == 20 ? "ที่ต้องจัดส่ง" : "จัดส่งสำเร็จ" }}
        </h6>
        <small class="text-muted">{{ item.deliveryDate.slice(0, 10) }}</small>
      </div>
    </app-timeline-item>
  </app-timeline>
  <!-- </b-card> -->
</template>

<script>
import { BCard, BImg, BMedia, BAvatar } from "bootstrap-vue";
import AppTimeline from "@core/components/app-timeline/AppTimeline.vue";
import AppTimelineItem from "@core/components/app-timeline/AppTimelineItem.vue";

export default {
  components: {
    BCard,
    BImg,
    BMedia,
    BAvatar,
    AppTimeline,
    AppTimelineItem,
  },
  props: {
    data: {
      type: Array,
    },
  },
  data() {
    return {};
  },
};
</script>

<style></style>
